import { Grid } from '@mui/material';
import CheckboxButton from '@components/CheckboxButton';
import React, { FC, Fragment } from 'react';
import { QuestionView, ResponseView } from '@views';
import { useNavigationEligibility } from '@components/SurveyDrawer/NavigationEligibilityContextProvider';
import Logger from '@utils/logger';
import { DateTime } from 'luxon';

interface MultiSelectResponseProps {
  currentQuestion: QuestionView;
}

export const MultiSelectResponse: FC<MultiSelectResponseProps> = ({ currentQuestion }) => {
  const currentStepResponses = currentQuestion.responses;
  const { triggerEligibility } = useNavigationEligibility();
  const setQuestionResponse = (currentQuestion: QuestionView, optIdx: number, e: any) => {
    currentQuestion.responses[optIdx].selected = Boolean(e.target.checked);
    if (e.target.checked) {
      currentQuestion.responses[optIdx].textResponse = String(e.target.value);
    }
  };
  const handleMultiSelectResponse = (e: any, option: ResponseView) => {
    const optIdx = currentQuestion.responses.findIndex((x) => x.id === option.id);
    currentQuestion.responses[optIdx].textResponse = '';
    setQuestionResponse(currentQuestion, optIdx, e);
    triggerEligibility();
  };
  return (
    <>
      {currentStepResponses.some((opt) => opt.responseType === 'MultiSelect') && (
        <Grid
          size={{ xs: 12 }}
          flexWrap={'wrap'}
          alignContent="center"
          justifyContent={'flex-start'}
          display={'flex'}
          gap={2}
        >
          {currentQuestion.responses.map((opt) => {
            const key = `option-${opt.id}`;
            if (opt.responseType === 'MultiSelect') {
              return (
                <CheckboxButton
                  checked={opt.selected}
                  value={opt.id}
                  key={key}
                  label={opt.text}
                  onChange={(e) => handleMultiSelectResponse(e, opt)}
                />
              );
            }
            return null;
          })}
        </Grid>
      )}
    </>
  );
};
